'use strict';

(function () {

    const selectedBlock = $('.selected-block');

    //Работа селект
    $('.select__header').on('click', function () {
        $(this).parents('.select').find('.select__body').slideToggle();
        $(this).parents('.select').toggleClass('is-active');
    });

    $('.select__body').on('click', '.select__item', function () {
        let text = $(this).text()
        $(this).parents('.select').find('.select__body').slideToggle();
        $(this).parents('.select').find('.select__current').text(text.trim());
        $(this).parents('.select').toggleClass('is-active');

        //Вставка для страницы pinclaim/medical-institution для отправки на бэк флага о выбере нужного типа информации
        if (location.href.indexOf('pinclaim/medical-institution') >= 0) {
            if (text.trim() === 'Загрузить справку') {
                $(this).parents('.reference--medical-institution').find('#insurer').val(false);
            } else {
                $(this).parents('.reference--medical-institution').find('#insurer').val(true);
            }
        }
        //Вставка для страницы protectionclaim/medical-institution для отправки на бэк флага о выбере нужного типа информации
        if (location.href.indexOf('protectionclaim/medical-institution') >= 0) {
            if (text.trim() === 'Загрузить справку') {
                $(this).parents('.reference--medical-institution').find('#insurer').val(false);
            } else {
                $(this).parents('.reference--medical-institution').find('#insurer').val(true);
            }
        }
    });

    $('.select__item').on('click', function () {
        const number = $(this).attr('data-select-number');

        if (selectedBlock.length) {
            selectedBlock.hide();
            $(`[data-block-number=${number}]`).slideDown();
        }
    });
})();
